import { FetchVehiclePricingRequest } from 'Services/Api/_HumanWritten/BookingWizardDataService';
import { BookingWizardData } from '../../BookingWizardData/BaseBookingWizardData';

export const convertToFetchVehiclePricingRequest = (wizardData: BookingWizardData): FetchVehiclePricingRequest => {
	if (wizardData.innerWizardData.type !== 'vehicle') {
		throw new Error('Must be a vehicle booking');
	}

	const journeys = [];

	if (wizardData.departingJourney) {
		journeys.push(wizardData.departingJourney);
	}

	if (wizardData.returningJourney) {
		journeys.push(wizardData.returningJourney);
	}

	const requestDto: FetchVehiclePricingRequest = {
		userId: wizardData.userId,
		journeys,
		departingJourney: wizardData.departingJourney!,
		returningJourney: !!wizardData.returningJourney ? wizardData.returningJourney : null,
		vehicleLengthId: !!wizardData.innerWizardData.vehicleLengthId
			? wizardData.innerWizardData.vehicleLengthId
			: null,
		vehicleWeightId: !!wizardData.innerWizardData.vehicleWeightId
			? wizardData.innerWizardData.vehicleWeightId
			: null,
		traielrLengthId: !!wizardData.innerWizardData.trailerLengthId
			? wizardData.innerWizardData.trailerLengthId
			: null,
		isEditMode: false,
		widthId: null,
		bookingId: null,
	};

	if (wizardData.wizardMode === 'ALTERATION') {
		requestDto.isEditMode = true;
		requestDto.widthId = !!wizardData.innerWizardData.vehicleWidthId
			? wizardData.innerWizardData.vehicleWidthId
			: null;
		requestDto.bookingId = wizardData.bookingToEdit!;
	}

	return requestDto;
};
